import script from "./item3.vue?vue&type=script&setup=true&lang=js"
export * from "./item3.vue?vue&type=script&setup=true&lang=js"

import "./item3.vue?vue&type=style&index=0&id=b6f61c8c&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6f61c8c"]])

export default __exports__